"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as t } from "../../../utils/styles.mjs";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { ChevronLeft as i, ChevronRight as a } from "@videoblocks/react-icons";
//#region src/components/molecules/Pagination/Pagination.tsx
var o = (e, t) => Array.from({ length: t - e }, (t, n) => n + e), s = (e, t, n = 5) => {
	let r = Math.max(1, Math.min(e - Math.floor((n - 3) / 2), t - n + 2)), i = Math.min(t, Math.max(e + Math.floor((n - 2) / 2), n - 1));
	return [
		...r > 2 ? [1, "…"] : r > 1 ? [1] : [],
		...o(r, i + 1),
		...i < t - 1 ? ["…", t] : i < t ? [t] : []
	];
}, c = "text-sm font-semibold leading-5", l = e(c, "cursor-pointer", t()), u = e(c, "flex items-center justify-center rounded-capsule px-[7px] bg-neutral-dark-1000 text-neutral-dark-100 pointer-events-none"), d = ({ resultsPerPage: t, totalResults: o, maxPage: d, currentPage: f, goTo: p, className: m }) => {
	let h = d ?? Math.max(1, Math.ceil((o ?? 0) / t)), g = s(f, h);
	return /* @__PURE__ */ n("div", {
		className: "flex justify-center w-full",
		children: /* @__PURE__ */ r("div", {
			className: e("flex items-center justify-center gap-6 px-6 py-4 min-w-[352px] rounded-md bg-neutral-dark-200 text-neutral-dark-1000", m),
			children: [
				f !== 1 && /* @__PURE__ */ n("button", {
					"aria-label": "Previous page",
					onClick: () => p(f - 1),
					className: l,
					children: /* @__PURE__ */ n(i, { className: "w-4 h-4 fill-current" })
				}),
				g.map((e, t) => e === "…" ? /* @__PURE__ */ n("span", {
					className: c,
					"aria-hidden": "true",
					children: "…"
				}, `ellipsis-${t}`) : e === f ? /* @__PURE__ */ n("button", {
					disabled: !0,
					"aria-current": "page",
					className: u,
					children: e
				}, e) : /* @__PURE__ */ n("button", {
					onClick: () => p(e),
					className: l,
					children: e
				}, e)),
				f !== h && /* @__PURE__ */ n("button", {
					"aria-label": "Next page",
					onClick: () => p(f + 1),
					className: l,
					children: /* @__PURE__ */ n(a, { className: "w-4 h-4 fill-current" })
				})
			]
		})
	});
};
//#endregion
export { d as Pagination, d as default };
